import collapsedReducer from './collapsedReducer';
import {combineReducers} from 'redux';

//Combine all the sub reducers
const rootReducer = combineReducers({
    collapsed: collapsedReducer
})

export default rootReducer